import React, { useState } from 'react';
import { SectionHeader } from './SectionHeader';
import { ProjectCard } from './ProjectCard';
import { ProjectDetailsDialog } from './ProjectDetailsDialog';

export const FeaturedProjectsSection = ({
  projects = [],
}) => {
  const [selectedProject, setSelectedProject] =
    useState(null);

  const handleCloseDialog = () => {
    setSelectedProject(null);
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          eyebrow="Selected Work"
          title="Featured Projects"
          subtitle="A collection of mobile apps, dashboards, and digital products built with clean architecture and premium user experience."
        />

        <div
          style={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '32px',
            marginTop: '42px',
            boxSizing: 'border-box',
          }}
        >
          {projects.map((project, index) => (
            <ProjectCard
              key={project?.id || index}
              project={project}
              onClick={() =>
                setSelectedProject(project)
              }
            />
          ))}
        </div>
      </div>

      <ProjectDetailsDialog
        open={!!selectedProject}
        project={selectedProject}
        onClose={handleCloseDialog}
      />
    </>
  );
};
